interface Props {
  [key: string]: any
}

function ExclamationCircleStrokeIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 22 25" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M10.873 1.35074C16.6843 1.35074 21.3953 6.0617 21.3953 11.873C21.3953 17.6843 16.6843 22.3953 10.873 22.3953C5.0617 22.3953 0.350742 17.6843 0.350742 11.873C0.350742 6.06171 5.06187 1.35074 10.873 1.35074Z"
        fill="#467AFF"
        stroke="white"
        strokeWidth="0.701485"
      />
      <g className={pathClassName ? `fill-current ${pathClassName}` : ''}>
        <path
          d="M9.93089 18H12.0642V9.55809H9.93089V18ZM11.0128 8.55238C11.7595 8.55238 12.3233 8.00381 12.3233 7.30286C12.3233 6.6019 11.7595 6.05333 11.0128 6.05333C10.2509 6.05333 9.70232 6.6019 9.70232 7.30286C9.70232 8.00381 10.2509 8.55238 11.0128 8.55238Z"
          fill="white"
        />
      </g>
    </svg>
  )
}

export default ExclamationCircleStrokeIcon
